var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well-status-overlay",class:_vm.$uiUtils.getStatusColor(_vm.well.status)})}
var staticRenderFns = []
export { render, staticRenderFns }